<template>
    <div class="bill-discounts-list-form form" ref="billDiscountsListFormElement">
        <BillDiscountsList class="col-md" @allDiscountsRemoved="close" @discountRemoved="onDiscountRemoved" />
    </div>
</template>

<script setup lang="ts">
    import { useTableAllocationStore } from "@/data/stores/tableAllocation";
    import { Logging } from "@/data/util/Logging";
    import { FloatLabel } from "@/shared/ui/FloatLabel";
    import { onMounted, ref, watch } from "vue";

    import BillDiscountsList from "@/components/payment/BillDiscountsList.vue";

    // define props
    const props = defineProps<{
        onClose: () => unknown;
        onDiscountRemoved: () => void;
    }>();

    const allocation = useTableAllocationStore();

    // define html refs
    const originalAllocationHash = ref<string | undefined>();
    const billDiscountsListFormElement = ref<HTMLElement | null>(null);

    const emit = defineEmits(["close"]);

    function close() {
        emit("close");
        props.onClose();
    }

    watch(
        () => allocation.hash,
        () => {
            if (allocation.hash != originalAllocationHash.value) {
                // if allocation has changed - close this modal
                Logging.LogInfo(
                    `Closing BillDiscountsListPopoverForm because allocation has changed - previous ${originalAllocationHash.value}, current ${allocation.hash}`
                );
                close();
            }
        }
    );

    onMounted(() => {
        originalAllocationHash.value = allocation.hash;
        FloatLabel.bind($(billDiscountsListFormElement.value!));
    });
</script>

<style lang="scss">
    .bill-discounts-list-form {
        padding: 0 0 3.5em;
    }
</style>
